import { newE2EPage } from '@stencil/core/testing';

describe('bd-button', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<bd-button></bd-button>');

    const element = await page.find('bd-button');
    expect(element).toHaveClass('hydrated');
  });
});
